import React from 'react'

import { StyleSheet, View, Keyboard, ScrollView, Image, Platform } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import client from '@sart/client'
import { prettyErrorMessage, testID } from '@sart/utilities'
import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import { GuruQuestion, CompanyIcon } from '@sart/icons'

import {
  Title,
  Description,
  Space,
  Button,
  TextInputExtended,
  KeyboardAvoidingView,
  ReturnFooter
} from '@sart/components'

import NeedHelpFooter from '../NeedHelpFooter'
import * as theme from './signTheme'

export default function ForgottenPassword(props) {
  const content = useContent()

  const { navigation } = props

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().trim().email(content.forms.emailInvalid).required(content.forms.required)
    }),
    onSubmit: handleForgottenPassword
  })

  async function handleForgottenPassword(values, form) {
    form.setSubmitting(true)
    //close the keyboard if it is open
    Keyboard.dismiss()
    values.email = values.email.trim().toLowerCase()
    try {
      const comms = await client.callApi('outboundCommunication','createOutboundCommsForgottenPasswd')

      comms.username = values.email
      comms.messageTemplate = 'FORGOTTEN-PASSWORD'

      await client.callApi('outboundCommunication','modifyOutboundCommsForgottenPasswd',[
         comms.outboundCommsId,
         comms
      ])

      navigation.navigate('ForgottenPasswordAuth', {
        emailAddress: values.email
      })
    } catch (error) {
      console.log(error);
      form.setFieldError(
        'email',
        prettyErrorMessage(error, 'forgottenPassword', content)
      )
      form.setSubmitting(false)      
    }
  }

  return (
    <ScrollView style={styles.scrollViewContainer} keyboardShouldPersistTaps={'always'}>
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView style={styles.content}>
        <View style={styles.logo}>
          <Image
              source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
              style={styles.logoImage}
          />
          {/* <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} alignSelf={"center"} /> */}
        </View>
        <Space height={24} />
        <Title {...theme.title}>{content.forgotten_password.title}</Title>

        <Space height={24} />

        <Description {...theme.description}>{content.forgotten_password.instructions}</Description>

        <Space height={24} />

        <TextInputExtended
          label={content.forgotten_password.emailLabel}
          keyboardType="email-address"
          autoCapitalize="none"
          value={formik.values.email}
          placeholder={content.forgotten_password.emailPlaceholder}
          footer={content.forgotten_password.note}
          onChangeText={formik.handleChange('email')}
          onBlur={formik.handleBlur('email')}
          error={formik.touched.email && formik.errors.email}
          {...theme.textInput}
          returnKeyType="go"
          onSubmitEditing={formik.handleSubmit}
          {...testID('forgottenPasswordEmail')}   
        />

        <Space height={48} />

        <Button
          title={
            formik.isSubmitting
              ? content.common.sending
              : content.common.send
          }
          disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
          onPress={formik.handleSubmit}
          {...theme.button}
          titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
          disabledTitleStyle={{...typography.extrabold, fontSize: 18, color: colors.white + 45}}     
          {...testID('forgottenPasswordButton')}   
          />

      <ReturnFooter
        cancelStyle={styles.cancelStyle}
        title={content.common.cancel}
        onPress={() => navigation.navigate('SignIn')}
      />
      
      </KeyboardAvoidingView>

    </SafeAreaView>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  scrollViewContainer: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
  },
  container: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    //alignItems: 'center'
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  content: {
    flex: 1,
    ...adaptive.wrapperPadding,
    //justifyContent: 'center',
    ...adaptive.passwordContentHeight,
    maxWidth: 600,
    width: '100%'
  },
  description: {
    textAlign: 'center',
  },
  cancelStyle: {
    color: colors.white
  },
  logo: {
    alignSelf:"center"
  },
  logoStyle: {
    ...adaptive.guruSize
  },
  logoImage: {
    height: 45,
    width: 45,
    position: 'relative',
    alignSelf: 'center',
    width: 200,
    ...adaptive.guruSize
  },
})
